const downloadBlob = (blob, filename, type) => {
  const url = window.URL.createObjectURL(
    new Blob([blob], {
      type: type || "text/csv",
    })
  );
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};

export default downloadBlob;
